export const Role = {
    ADMIN: 'admin',
    USER: 'user',
    SUPER: 'super',
}